var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0936 1.70948C11.3909 1.8155 11.5894 2.09679 11.5894 2.41213V7.56722H16.7505C17.0391 7.56722 17.3019 7.7333 17.4255 7.99381C17.5491 8.25431 17.5114 8.56263 17.3286 8.78574L9.73259 18.059C9.53267 18.3031 9.20072 18.3952 8.90338 18.2892C8.60604 18.1832 8.40755 17.9019 8.40755 17.5866V12.4315H3.24646C2.95785 12.4315 2.69507 12.2654 2.57147 12.0049C2.44788 11.7444 2.4856 11.4361 2.66836 11.213L10.2644 1.93969C10.4643 1.69562 10.7963 1.60347 11.0936 1.70948ZM4.8227 10.9393H9.15449C9.56702 10.9393 9.90144 11.2733 9.90144 11.6854V15.4965L15.1743 9.05938H10.8425C10.43 9.05938 10.0956 8.72535 10.0956 8.3133V4.5022L4.8227 10.9393Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugin);
export default __webpack_public_path__ + "static/media/plugin.81568c2a619ffb3ffb0d7b6268e37672.svg";
export { ForwardRef as ReactComponent };